import type { ReactElement } from 'react';

export type NavIconName =
  | 'overview'
  | 'stores'
  | 'screens'
  | 'media'
  | 'playlists'
  | 'devices'
  | 'audit';

export function NavIcon({ name }: { name: NavIconName }): ReactElement {
  return (
    <svg
      className="nav-icon"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {SHAPES[name]}
    </svg>
  );
}

const SHAPES: Record<NavIconName, ReactElement> = {
  overview: (
    <>
      <rect x="2.5" y="2.5" width="6" height="6" rx="1.2" />
      <rect x="11.5" y="2.5" width="6" height="6" rx="1.2" />
      <rect x="2.5" y="11.5" width="6" height="6" rx="1.2" />
      <rect x="11.5" y="11.5" width="6" height="6" rx="1.2" />
    </>
  ),
  stores: (
    <>
      <path d="M3 8v8.5h14V8" />
      <path d="M2 8l1.8-4h12.4L18 8a2.2 2.2 0 0 1-4 0 2.2 2.2 0 0 1-4 0 2.2 2.2 0 0 1-4 0 2.2 2.2 0 0 1-4 0Z" />
      <path d="M8 16.5v-4h4v4" />
    </>
  ),
  screens: (
    <>
      <rect x="2.5" y="3.5" width="15" height="10" rx="1.4" />
      <path d="M7 16.5h6" />
      <path d="M10 13.5v3" />
    </>
  ),
  media: (
    <>
      <rect x="2.5" y="3.5" width="15" height="13" rx="1.6" />
      <circle cx="7" cy="8" r="1.4" />
      <path d="M3 14l4-3.5 3.5 3 2.5-2 4 3.5" />
    </>
  ),
  playlists: (
    <>
      <path d="M3 5h9" />
      <path d="M3 10h9" />
      <path d="M3 15h6" />
      <path d="M14 8.5l4 2.5-4 2.5Z" />
    </>
  ),
  devices: (
    <>
      <rect x="2.5" y="3.5" width="15" height="10" rx="1.4" />
      <path d="M7 16.5h6" />
      <path d="M8.2 9.6a3 3 0 0 1 3.6 0" />
      <path d="M6.4 7.4a5.6 5.6 0 0 1 7.2 0" />
    </>
  ),
  audit: (
    <>
      <path d="M4.5 2.5h7L15.5 6.5v11h-11Z" />
      <path d="M11.5 2.5v4h4" />
      <path d="M7 10h6" />
      <path d="M7 13.5h4" />
    </>
  ),
};
